import React, { FC } from 'react';
import { useLocale } from 'lib';
import { Chip } from 'components/atoms';
import styles from './style.module.scss';

export { useVersionCheck } from './useVersionCheck';

export const VersionUpdatePrompt: FC = () => {

  const { t } = useLocale();

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.title}>
          {t('Version_Update_Modal.Title')}
        </div>
        <div className={styles.body}>
          {t('Version_Update_Modal.Body')}
        </div>
        <Chip
          className={styles.reloadChip}
          size="large"
          variant="primary"
          label={t('Version_Update_Modal.Reload')}
          onClick={() => window.location.reload()}
        />
      </div>
    </div>
  );

};
